'use client';

import { useCallback, useState } from 'react';

/**
 * Custom hook to handle user logout logic.
 * Simply navigates to /auth/logout where the server handles cookie clearing and redirect.
 *
 * @returns An object containing the logout function and loading state.
 *          - logout: Function to initiate the logout process.
 *          - isLoading: Boolean indicating if the logout process is in progress.
 */
export const useLogout = () => {
  const [isLoading, setIsLoading] = useState(false);

  const logout = useCallback(() => {
    setIsLoading(true);
    // Direct navigation - server handles cookie clearing and redirect
    window.location.href = '/auth/logout';
  }, []);

  return { logout, isLoading };
};
